import { IconButton } from './button';

/** The list with the item at `from` moved to `to`, e.g. for `ReorderButtons`. */
export function moveItem<T>(items: readonly T[], from: number, to: number): T[] {
  const next = [...items];
  if (from < 0 || from >= next.length || to < 0 || to >= next.length) return next;
  next.splice(to, 0, ...next.splice(from, 1));
  return next;
}

export interface ReorderButtonsProps {
  /** Position of the item in the list. */
  index: number;
  /** Number of items in the list. */
  count: number;
  onMove: (from: number, to: number) => void;
  /** Accessible names naming the item, e.g. „„Türen“ nach oben“. */
  upLabel: string;
  downLabel: string;
  disabled?: boolean;
}

/**
 * Moves an item up or down by one: the way to reorder lists that works with keyboard, screen
 * reader and touch alike, without dragging (WCAG 2.5.7).
 */
export function ReorderButtons({
  index,
  count,
  onMove,
  upLabel,
  downLabel,
  disabled = false,
}: ReorderButtonsProps) {
  return (
    <span className="flex">
      <IconButton
        icon="arrow-up"
        size="sm"
        label={upLabel}
        disabled={disabled || index === 0}
        onClick={(event) => {
          event.stopPropagation();
          onMove(index, index - 1);
        }}
      />
      <IconButton
        icon="arrow-down"
        size="sm"
        label={downLabel}
        disabled={disabled || index >= count - 1}
        onClick={(event) => {
          event.stopPropagation();
          onMove(index, index + 1);
        }}
      />
    </span>
  );
}
